import Immutable from 'immutable';

const UPDATE_REVIEWS = 'reviews/update_reviews';

const PAGE_SIZE = 5;

const initialState = Immutable.fromJS({});

export default function(state = initialState, action = {}) {

    switch (action.type) {
        case UPDATE_REVIEWS:
            const newStarsList = action.isFilter ? action.list.stars : state.get('stars').push(...action.list.stars).toJS();
            state = state.update('stars', () => Immutable.fromJS(newStarsList));
            state = state.update('has_more_pages', () => action.list.has_more_pages);
            state = state.update('type', () => action.filterType);
            state = state.update('last_star_rating_id', () => action.list.last_star_rating_id);
            return state;
        default:
            return state;
    }
}

export function updateReviews(list, filterType, isFilter) {
    return {
        type: UPDATE_REVIEWS,
        filterType,
        isFilter,
        list
    };
}

/** Load More & Order By reviews */
export function fetchReviews(event, type, lastStar) {
    return function(dispatch, state) {

        const isFilter = event.target.tagName === 'SELECT',
            filterType = (isFilter) ? event.target.value : type,
            idType = state().get('gigId') ? 'gig' : 'user',
            id = state().get(`${idType}Id`);

        let url = `/ratings/index?${idType}_id=${id}&type=${filterType}&page_size=${PAGE_SIZE}`;

        if (!isFilter) {
            url += `&last_star_rating_id=${lastStar}`;
        }

        gofor(url)
            .then((response) => {
                if (!response.ok) { throw new Error(response.statusText); }

                return response.json();
            })
            .then((res) => {
                dispatch(updateReviews(res, filterType, isFilter));
            });
    };
}



// WEBPACK FOOTER //
// ./src/reviews/module.js